module.exports = __webpack_public_path__ + "static/media/arrow-down.f6e89f48.svg";